import { render, staticRenderFns } from "./LogCenter.vue?vue&type=template&id=1c899ace&"
import script from "./LogCenter.vue?vue&type=script&lang=js&"
export * from "./LogCenter.vue?vue&type=script&lang=js&"
import style0 from "./LogCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports